import React, { useState, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { firestore, doc, setDoc } from '../firebase-config';
import '../styles/ContentEditor.css';

const ContentEditor = ({ pageId, initialSections = [], onSave }) => {
  const [sections, setSections] = useState(
    initialSections.length > 0 ? initialSections : [{ title: '', content: '<p></p>' }]
  );
  const [saving, setSaving] = useState(false);
  const editorRefs = useRef([]);

  const handleTitleChange = (index, value) => {
    const newSections = [...sections];
    newSections[index] = { ...newSections[index], title: value };
    setSections(newSections);
    onSave(newSections);
  };

  const addSection = () => {
    if (sections.length >= 11) {
      alert('Maximum 11 sections allowed.');
      return;
    }
    setSections([...sections, { title: '', content: '<p></p>' }]);
  };

  const removeSection = (index) => {
    if (sections.length === 1) {
      alert('At least one section is required.');
      return;
    }
    editorRefs.current.splice(index, 1);
    const newSections = sections.filter((_, i) => i !== index);
    setSections(newSections);
    onSave(newSections);
  };

  const handleSave = async () => {
    // Collect latest content from all TinyMCE editors
    const latestSections = sections.map((section, index) => ({
      ...section,
      content: editorRefs.current[index]
        ? editorRefs.current[index].getContent()
        : section.content,
    }));

    setSaving(true);
    try {
      const pageRef = doc(firestore, 'pageContent', pageId);
      await setDoc(pageRef, { sections: latestSections }, { merge: true });
      setSections(latestSections);
      onSave(latestSections);
      alert('Content saved successfully!');
    } catch (error) {
      console.error('Save error:', error);
      alert('Error saving content: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="content-editor">
      {sections.map((section, index) => (
        <div key={index} className="section">
          <input
            type="text"
            value={section.title}
            onChange={(e) => handleTitleChange(index, e.target.value)}
            placeholder={`Section ${index + 1} Title`}
            className="title-input"
          />
          <Editor
            apiKey="16nd2n35tc4ttll8gn95tptzucifo08um2cckdi6rbntk7ha"
            onInit={(evt, editor) => (editorRefs.current[index] = editor)}
            initialValue={section.content}
            init={{
              height: 500,
              menubar: false,
              plugins: [
                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
              ],
              toolbar:
                'undo redo | blocks | ' +
                'bold italic forecolor | alignleft aligncenter ' +
                'alignright alignjustify | bullist numlist outdent indent | ' +
                'removeformat | help',
              content_style:
                'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
            }}
          />
          <button
            onClick={() => removeSection(index)}
            className="remove-section-button"
            disabled={sections.length === 1}
          >
            Remove Section
          </button>
        </div>
      ))}
      <button onClick={addSection} className="add-section-button">
        Add New Section
      </button>
      <button onClick={handleSave} disabled={saving} className="save-button">
        {saving ? 'Saving...' : 'Save Changes'}
      </button>
    </div>
  );
};

export default ContentEditor;